<template>
    <div class="marque-date-range-picker" :class="disabled ? 'is-disabled' : ''" :style="'width: ' + this.width">
         <picker 
            :dateRange="dateRange"
            @update="updated"
            :locale-data="locale"
            :opens="opens"       
            :disabled="disabled"
        >
            <div slot="input" slot-scope="picker">
                <slot name="input">
                    <div>
                        <span class="material-icons" style="vertical-align: middle;">date_range</span>
                        {{ picker.startDate | formatDate(format) }} - {{ picker.endDate | formatDate(format) }}
                    </div>
                </slot>
            </div>
        </picker>
    </div>
</template>

<style lang="scss">
    .marque-date-range-picker {
        .is-disabled div.form-control.reportrange-text {
            color: rgba(0, 0, 0, 0.38);
        }
        .vue-daterange-picker { width: 100%; }
        .vue-daterange-picker .form-control { height: auto; }
        .drp-selected { display: none; }
        div.form-control.reportrange-text {
            font-size: 1rem;
            border-color: transparent;
            text-align: center;
            background: #f8f8f8;
            border-radius: 3px;
            padding: 10px 15px;
            &:after {
                margin-top: .15rem;
            }
        }

        &:hover:not(.is-disabled) div.form-control.reportrange-text {
            background: #f0f0f0;
        }
    }
</style>

<script>
import Moment from 'moment'
import Picker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'
import Filters from '../../../filters'

export default {
    filters: Filters,
    components: { Picker },
    props: {
        startDate: {
            type: Date,
            default() {
                return Moment().startOf('month')
            }
        },
        endDate: {
            type: Date,
            default() {
                return Moment().endOf('month')
            }
        },
        opens: {
            type: String,
            default() {
                return 'left'
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        format: {
            type: String,
            default: 'D MMM, YYYY'
        },
        width: {
            type: String,
            default: 'auto'
        },
        ranges: {
            type: Object,
            default() {
                return  { //default value for ranges object (if you set this to false ranges will no be rendered)
                    'Today': [Moment(), Moment()],
                    'Yesterday': [Moment().subtract(1, 'days'), Moment().subtract(1, 'days')],
                    'This month': [Moment().startOf('month'), Moment().endOf('month')],
                    'This year': [Moment().startOf('year'), Moment().endOf('year')],
                    'Last week': [Moment().subtract(1, 'week').startOf('week'), Moment().subtract(1, 'week').endOf('week')],
                    'Last month': [Moment().subtract(1, 'month').startOf('month'), Moment().subtract(1, 'month').endOf('month')],
                }
            }
        }
    },
    methods: {
        updated(e) {
            if (!this.disabled) {
                this.$emit('input', {
                    startDate: Moment(e.startDate).hours(0).minutes(0).seconds(0).toDate(),
                    endDate: Moment(e.endDate).hours(23).minutes(59).seconds(59).toDate(),
                })
            }
        },
    },
    computed: {
        dateRange() {
            return {
                startDate: this.startDate,
                endDate: this.endDate
            }
        }
    },
    data() {
        return {
            locale: {
                direction: 'ltr', //direction of text
                format: this.format,//: 'DD-MM-YYYY', //fomart of the dates displayed
                separator: ' - ', //separator between the two ranges
                applyLabel: 'Apply',
                cancelLabel: 'Cancel',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: Moment.weekdaysMin(), //array of days - see moment documenations for details
                monthNames: Moment.monthsShort(), //array of month names - see moment documenations for details
                firstDay: 1, //ISO first day of week - see moment documenations for details
                showWeekNumbers: false //show week numbers on each row of the calendar
            },
        }
    }
}
</script>